import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from "vue";
import { useRoute } from "vue-router";
import "normalize.css";
import "@/global/icons";
import "@/global/styles.scss"; /** keep these last so they take priority */
import TheBanner from "./components/TheBanner.vue";
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import TheFloatButtons from "@/components/TheFloatButtons.vue";
import TheSnackbar from "./components/TheSnackbar.vue";
import { appTitle, appDescription, appUrl } from "@/global/meta";

/** route info */

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

/** when route changes, update document meta data. see https://metatags.io/ */
watch(
  () => route.fullPath,
  async () => {
    /**
     * meta vars set in components should override this, since this component is
     * root and renders first.
     */

    /** update document title from route */
    appTitle.value = [String(route.name)];

    /** update description */
    appDescription.value = route.meta.description as string;

    /** update canonical url */
    appUrl.value = window.location.href;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheBanner),
    _createVNode(TheHeader),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view),
      _createVNode(TheFloatButtons),
      _createVNode(TheSnackbar)
    ]),
    _createVNode(TheFooter)
  ], 64))
}
}

})